const config = {
  gaTrackingCode: 'UA-105626287-1',
  organizzazione: 'CISL',
  logo: 'logo_sportellolavoro.png'
};

export default config;